module.exports = __webpack_public_path__ + "534f35774f257667b3db307d384f5df0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/festival-yurt.png
// module id = 555
// module chunks = 0